<template>
  <title-tab :msg="$t('title.cashback')">  
    <v-card
      flat
      class="py-5 mt-3 px-2 d-flex justify-center"
    >
      <v-row
        no-gutters
        class="main-container-bonus"
      > 
        <v-col
          cols="12"
        >
          <div class="text--play">
            <p class="mb-0">
              คืนเงินทุกยอดเล่น
            </p>
            <p class="text--play-sub">
              กด <strong class="red--text">รับฟรี</strong> ที่นี่ได้ทุกวัน
            </p>
          </div>
        </v-col>
        <v-col
          cols="12"
        >
          <div class="d-flex justify-center image-wrapper">
            <img
              src="@/assets/cashback2/circle.png"
              alt=""
            >
            <div class="centered-text">
              <span class="bonus-01">โบนัสเงินคืน</span>
              <span class="bonus-02">ยอดคงเหลือ</span>
              <span class="bonus-03">{{ cashback.remain | currency }}</span>
            </div>
          </div>
        </v-col>
        
        <v-col
          cols="12"
        >
          <div class="d-flex game-layout mt-10 my-5">
            <div 
              v-if="parseFloat(findCashbackPercent(4)) != 0"
              class="d-flex game-percent-main"
            >
              <div class="d-flex items-center">
                <img
                  src="@/assets/cashback2/slot.png"
                  alt=""
                >
              </div>
              <div class="d-flex game-percent g-slot">
                <span>สล็อต</span>
                <strong>{{ findCashbackPercent(4) }}%</strong>
              </div>
            </div>

            <div
              v-if="parseFloat(findCashbackPercent(2)) != 0" 
              class="d-flex game-percent-main"
            >
              <div class="d-flex items-center">
                <img
                  src="@/assets/cashback2/casino.png"
                  alt=""
                >
              </div>
              <div class="d-flex game-percent g-casino">
                <span>คาสิโน</span>
                <strong>{{ findCashbackPercent(2) }}%</strong>
              </div>
            </div>

            <div 
              v-if="parseFloat(findCashbackPercent(3)) != 0"
              class="d-flex game-percent-main"
            >
              <div class="d-flex items-center">
                <img
                  src="@/assets/cashback2/spot.png"
                  alt=""
                >
              </div>
              <div class="d-flex game-percent g-sport">
                <span>กีฬา</span>
                <strong>{{ findCashbackPercent(3) }}%</strong>
              </div>
            </div>
          </div>
        </v-col>

        <v-col
          cols="12"
        >
          <div class="pa-2 mt-2">
            <div class="d-flex justify-space-between">
              <span class="grey--text">ยอดเงินคืนทั้งหมด</span>
              <span class="cashback-amount">{{ cashback.total | currency }}</span>
            </div>
            <div class="d-flex justify-space-between">
              <span class="grey--text">ยอดเงินคืนที่ยังรับได้</span>
              <span class="cashback-amount">{{ cashback.remain | currency }}</span>
            </div>
            <v-btn
              depressed
              color="#6450FE"
              class="mt-5"
              block
              dark
              @click="openDialogWithdraw()"
            >
              <div class="flex justify-center items-center gap-1">
                <span>ถอนโบนัสเงินคืน</span>
                <div>
                  <v-img
                    width="16"
                    src="@/assets/cashback2/cash.png"
                  />
                </div>
              </div>
            </v-btn>
          </div>
        </v-col>

        <v-col
          cols="12"
        >
          <div class="card-rule pa-2 mt-2">
            <div class="rule--title">
              📝กติกาโบนัสเงินคืน📝
            </div>
            <p class="rule--desc">
              <ol>
                <li>เล่นเกม คาสิโน, สล็อต หรือกีฬา ทุกยอดเดิมพันจะได้รับเงินคืน</li>
                <li>ระบบคืนเงินให้ 0.50% ของยอดที่เล่น ไม่ว่าจะ ได้, เสีย หรือเสมอ</li>
                <li>เงินคืนจะถูกเก็บไว้ใน กระเป๋าแคชแบค โดยอัตโนมัติ</li>
                <li>ผู้เล่นสามารถ กดรับเงินคืนได้ตลอดเวลา ไม่ต้องรอรอบตัดยอด</li>
                <li>กดรับได้ ไม่จำกัดจำนวนครั้งต่อวัน จะกี่รอบก็ได้</li>
                <li>เงินคืน ไม่มีวันหมดอายุ สามารถสะสมไว้ได้นานเท่าที่ต้องการ</li>
                <li>เมื่อกดรับ ระบบจะโอนเงินจาก กระเป๋าแคชแบค เข้าสู่ กระเป๋าหลัก ทันที</li>
                <li>ผู้เล่นสามารถ ตรวจสอบยอดเล่น และยอดคืน ได้อย่างละเอียด</li>
                <li>เว็บหวยทั่วไปไม่มีระบบคืนยอดเล่น แต่ที่นี่ เราคืนจริงทุกยอด อย่างโปร่งใส</li>
              </ol>
            </p>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <dialogWithdraw
      ref="dialogWithdrawRef"
      :user-profile="userProfile"
      @success="getMeCashBack"
    />
  </title-tab>
</template>
<script>
import { cashback as apiCashback, me as apiMe } from '@/apis'
import dialogWithdraw from './child/dialogCashback' 

export default {
  components : {
    dialogWithdraw
  },
  data () {
    return {
      myCashBack : [],
      cashbackTier : [],
      cashback: {},
    }
  },
  computed : {
    wallet () {
      return this.$store.getters['userProfile/GETTERS_WALLET']
    },
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
  },
  async created () {
      await this.getMyCashBack()
      await this.getMeCashBack()
  },

  methods : {  

    openDialogWithdraw () { 
      this.$refs.dialogWithdrawRef.open(this.cashback.remain)
    },

    async getMyCashBack () {
      const [err,data] = await apiCashback.get()
      
      if(err) {
        this.submitstatus = !this.submitstatus
        this.$alert('',err,'warning')  
        return
      }

      this.myCashBack = data 
    },
    async getMeCashBack () {
      const [err, data] = await apiMe.getCashback()
      
      if(err) {
        this.submitstatus = !this.submitstatus
        this.$alert('',err,'warning')  
        return
      }

      this.cashback = data 
    },
    
    findCashbackPercent (category_game_type_id) {
      const match = this.myCashBack.find(
        (x) => x?.category_game_type?.id === category_game_type_id
      );
      return match?.cashback_percent ?? "0.00";
    }
  }
}
</script>
<style>
.main-container-bonus {
  max-width: 768px;
}

.text--play {
  color: #6450FE;
  font-size: 1.625rem;
  text-align: center;
}

.text--play-sub {
  font-size: 1.25rem;
}

.rule--title {
  text-align: center;
  width: 100%;
  font-weight: bold;
  margin-bottom: 4px;
  white-space: nowrap;
  font-size: 1.625rem;
  width: fit-content;
  margin: 0 auto;
}

.rule--desc {
  color: black;
  margin-top: 8px;
}

.rule-desc {
  text-indent: 1.5em;
  line-height: 1.125;
}

.card-rule {
  border-radius: 8px;
  border-style: dashed;
  border-color: #FC7276;
  color: #FC7276;
}

.image-wrapper {
  position: relative;
  display: inline-block; /* Keeps wrapper size based on image */
  text-align: center;
}

.centered-text {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  color: #6450FE;
  line-height: 1.25;
}

.game-layout {
  justify-content: space-around;
}

.game-percent-main {
  gap: 8px;
}

.game-percent {
  flex-direction: column;
  line-height: 1.2;
}

.g-slot {
  color: #FC7276;
}

.g-casino, .cashback-amount {
  color: #6450FE;
}

.g-sport {
  color: #1BBD02;
}

.bonus-02 {
  font-size: 1.5rem;
}

.bonus-03 {
  font-size: 2rem;
}
</style>